import Flickity from "flickity"
const heroElements = Array.from(document.querySelectorAll(".js-hero-flickity"))
heroElements.forEach((hero) => {
	new Flickity(hero, {
		wrapAround: true,
		autoPlay: 6000,
	})
})